module.exports = __webpack_public_path__ + "media/images/classpoints/arrow-narrow-left-b0c20acbd0a5c39b3056aeefe41106f2.svg";